
import React, { Component } from 'react';
import { API_PATH2 } from './config.js';
import axios from 'axios';
import Slider from "react-slick";

class Home extends Component {
    constructor (props) {
        super(props)
        this.state = {
            loading: true,
            campanias: [],
            comInterna: [],
            saibaMas:[],
            error: null,
        }
    }

    componentDidMount() {
    setTimeout(() => {
       this.fetchPages();
    }, 100);
  }

    fetchPages = () => {
        this.setState({ loading: true, error: null });

        // Peticiones paralelas a las dos páginas
        const campaniasRequest = axios.get(API_PATH2 + 'campanhas?page=1&per_page=100');
        const avisosRequest = axios.get(API_PATH2 + 'avisos?order=asc');
        const saibamasRequest = axios.get(API_PATH2 + 'carrusel_4?order=asc');

        Promise.all([campaniasRequest, avisosRequest, saibamasRequest])
        .then(([campaniasResponse, avisosResponse, saibamasResponse]) => {
            const campaniasPage = campaniasResponse.data;
            const avisosPage = avisosResponse.data;
            const saibamasPage= saibamasResponse.data;

            this.setState({
                campanias: campaniasPage,
                comInterna: avisosPage,
                saibaMas:saibamasPage,
                loading: false,
            });
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
            this.setState({ error: 'Error al cargar las páginas', loading: false });
        });
    };

    Sanitize(title) {
        var rawMarkup = title;
        return { __html: rawMarkup };
    }

    render() {   
        const { loading,campanias,comInterna,saibaMas  } = this.state;
        const settings_1 = {
            dots: false,
            fade: true,
            infinite: true,
            speed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,   
        };

        return (
                <div className="container">   
                    <div className='row'>
                        <div className='col-md-12 texto-centro'>
                            <br/>
                            <span className="titulo_bienvenida" >
                            Bem-vindo ao portal de quem trabalha na WMcCann
                            </span>
                        </div>
                    </div>
                    <br/>
                    <div className='row'>
                        <div className='col-md-6 pad-25'>
                            <Slider {...settings_1}> 
                                {campanias.slice(0, 3).map((campanha, i) => {
                                    return (
                                    <div className="container-home" key={i}>
                                        <a href={`comunicacao-externa/${campanha.id}`}  >
                                            <img  src={campanha.acf.imagen}/>
                                            <div className="text-box">
                                                <span className="message-news-title">Por dentro da WMcCann</span>
                                                <h3 className="message-news-home" dangerouslySetInnerHTML={{ __html: campanha.title.rendered }} />
                                            </div>
                                            </a>
                                        </div>
                                    );
                                })}
                            </Slider>  
                        </div>
                        <div className='col-md-6 pad-25'>
                            <Slider {...settings_1}> 
                                {comInterna.slice(0, 3).map((news, i) => {
                                    return (
                                    <div className="container-home" key={i}>
                                        <a href={`comunicacion-interna/${news.id}`}  >
                                            <img  src={news.acf.imagen}/>
                                            <div className="text-box">
                                                <span className="message-news-title">Por dentro da WMcCann</span>
                                                <h3 className="message-news-home" dangerouslySetInnerHTML={{ __html: news.title.rendered }} />
                                            </div>
                                            </a>
                                        </div>
                                    );
                                })}
                            </Slider> 
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6 pad-25'>
                            <div className="container-home">
                                <embed type="text/html" className="responsive-iframe" scrolling="no" src="/wp-content/src/insta.html" title="description"/>
                                <div className="text-box">
                                    <span className="message-news-title">Redes Sociais</span>
                                    <h3 className="message-news-home">Acompanhe nosso Instagram</h3>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-6 pad-25'>
                            <Slider {...settings_1}> 
                                {saibaMas.slice(0, 3).map((saiba, i) => {
                                    return (
                                    <div className="container-home" key={i}>
                                        <a href={saiba.acf.url_externo} target='_blank' >
                                            <img  src={saiba.acf.imagen}/>
                                            <div className="text-box">
                                                <span className="message-news-title">Saiba mais</span>
                                                <h3 className="message-news-home" dangerouslySetInnerHTML={{ __html: saiba.title.rendered }} />
                                            </div>
                                            </a>
                                        </div>
                                    );
                                })}
                            </Slider> 
                        </div>
                    </div>
                </div>
        )
    }
}

export default (Home)